import { useTranslation } from 'react-i18next';

export const useTasksTranslation = () => useTranslation('tasks');
